import React, { useState, useEffect, useContext, useRef } from 'react'
import { CommonInput, CommonModal, CustomPagination, CustomSelect } from 'components'
import { AddButton } from 'components/common/CommonButton'
import { AddMasterLocationModal, AddRateModal } from 'modals'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import StorageService from 'utils/StorageServices/StorageServices'
import BootstrapTable from 'components/BootstrapTable'
import { UserContext } from 'context'
import { activeInactiveRateStatus, deleteRateData, getRateListData } from '_services/accountsServices/rateServices'
import LoadingBar from 'react-top-loading-bar';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import toast from 'react-hot-toast';
import { constant } from 'constants'
import { getContractDropdownListData } from '_services/dropdownServices/dropdownService'
import RateDetailsModal from 'modals/RateDetailsModal'
import useDocumentTitle from 'hooks/useDocumentTitle'
import { fetchConsignorDetailsData } from '_services/accountsServices/consignorServices'
import { use } from 'react'

const Location = ({ details }) => {
    useDocumentTitle("Location | T360");
    let { id } = useParams();
    const loadingBarRef = useRef(null);
    const { masterData } = useContext(UserContext)
    const company_id = StorageService.getCompanyId();
    const [show, setShow] = useState(false)
    const [rateList, setRateList] = useState([]);
    const [contractList, setContractList] = useState([]);
    const [isRateDetails, setIsRateDetails] = useState(false);
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const [loading, setLoading] = useState(false);
    const [isDelete, setIsDelete] = useState(false);

    const itemsPerPage = 100;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 100,
        offset: 1,
        status: { label: 'All', value: '' },
        contract_id: {},
        search: '',
    });

    const [detailsData, setDetailsData] = useState({});
    const [addressId, setAddressId] = useState({
        id: "",
        title: "location",
        view: false,
    });

    const getDataConsignorDetails = async (id_1, id_2) => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                consignor_id: id_1,
                company_id: id_2,
            };
            const res = await fetchConsignorDetailsData(object);
            if (res?.responseCode == 200) {
                setDetailsData(res?.data?.consignor);
            }
        } catch (error) {
            console.error(error);
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    };

    // useEffect(() => {
    //     if (id && company_id) {
    //         getDataConsignorDetails(id, company_id);
    //     }
    // }, [id]);

    useEffect(() => {
        setDetailsData(details?.consignor)
    }, [details])

    const getListRateData = async (id_1, id_2) => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                ...filter,
                search: filter?.search,
                consignor_id: id_1,
                company_id: id_2,
            }
            const res = await getRateListData(object);
            if (res?.responseCode == 200) {
                setRateList(res?.data?.rate_list);
                setTotalItems(res?.data?.total_record);
            }
        } catch (error) {
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    useEffect(() => {
        if (filter?.contract_id?.value) {
            getListRateData(id, company_id);
        }

    }, [show, filter])

    let propsObject = {
        isOpen: show,
        closeModal: () => setShow(!show),
        headerPart: true,
        footerPart: true,
        modalMainClass: "_mdModal",
        modalTitle: "Add Rate",
    }

    let rateDetailsProps = {
        isOpen: isRateDetails,
        closeModal: () => setIsRateDetails(false),
        headerPart: true,
        footerPart: true,
        hideFooterSumbmitBtn: true,
        modalMainClass: "_mdModal",
        modalTitle: "Rate Details",
    }

    const handleStatusEvent = async (data, ind) => {
        try {
            const payload = {
                company_id: company_id,
                active: data?.active === 1 ? 0 : 1, // active = 1 , inactive = 0
                consignor_id: data?.consignor_id?._id,
                contract_id: data?.contract_id?._id,
                contract_rate_id: data?._id,
            };

            const res = await activeInactiveRateStatus(payload);
            if (res?.responseCode === 200) {
                let list = [...rateList];
                list.splice(ind, 1, { ...list[ind], active: data?.active === 1 ? 0 : 1 })
                setRateList(list);
                if (res?.responseMessage) {
                    toast.success('Status update successfully');
                }
            } else {
                toast.error(`Invalid Request !!`);
            }
        } catch (error) {
            toast.error(`Invalid Request !!`);
        }
    };



    const deleteHandler = (item) => {
        setIsDelete(item)
    }

    const submitDeleteContract = async () => {
        setLoading(true);
        try {
            let object = {
                company_id: isDelete?.company_id,
                contract_id: isDelete?.contract_id?._id,
                consignor_id: isDelete?.consignor_id?._id,
                contract_rate_id: isDelete?._id,
            }
            const res = await deleteRateData(object);
            if (res?.responseCode == 200) {
                toast.success(`${res?.responseMessage}`);
                getListRateData(id, company_id);
                setLoading(false);
                setIsDelete(false);
            } else {
                toast.success('Error !! ');
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // throw error;
        }
    }

    let contractDeleteProps = {
        isOpen: isDelete,
        closeModal: setIsDelete,
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: submitDeleteContract,
        isLoadding: loading,
    }

    const column = [
        { header: "", accessor: "serial" },
        { header: "Location Type", accessor: "locatioType" },
        { header: "Attention", accessor: "attention" },
        { header: "Address", accessor: "fullAddress" },
        { header: "Contact Number", accessor: "contact_no" },
        { header: "Email ID", accessor: "email" },
        { header: "State", accessor: "stateName" },
        { header: "GST Number", accessor: "gst_no" },
        { header: "Status", accessor: "status" },
    ];

    const rowDataList = (data) => {
        const listArray = data?.map((item, i) => ({
            ...item,
            serial: <>
                <div className="signDropdown">
                    <button className="dropbtn11">
                        <BsThreeDotsVertical />
                    </button>
                    <div className="dropdownContent">
                        <Link
                            // to={`/account/rate_details/${item?.consignor_id?._id}/${item?.contract_id?._id}/${item?._id}`}
                            className='_avPointer'
                            onClick={() => {
                                setAddressId({
                                    ...addressId,
                                    id: item?._id,
                                    title: "address",
                                    view: true,
                                    isDetailsOnly: true,
                                });
                                setShowOffcanvas(true);
                            }}
                            style={{ textDecoration: 'none' }}
                        >
                            <span className='_samAnchor'>
                                <span className='viewIcon_avt'>
                                    <AiOutlineEye />
                                </span>View
                            </span>
                        </Link>

                        {item?.location_type != 1 && <Link
                            onClick={() => {
                                setAddressId({
                                    ...addressId,
                                    id: item?._id,
                                    title: "loaction",
                                    view: false,
                                });
                                setShowOffcanvas(true);
                            }}
                            className="_avPointer"
                            style={{ textDecoration: "none" }}
                        >
                            <span className="_samAnchor">
                                <span className="viewIcon_avt">
                                    <FiEdit />
                                </span>
                                &nbsp; Edit
                            </span>
                        </Link>}
                        <></>

                    </div>
                </div>
            </>,
            contract_no: (
                <>
                    <Link onClick={() => setIsRateDetails(item)} style={{ textDecoration: 'none' }}>{item?.contract_id?.code}</Link>
                </>
            ),
            locatioType: <>{item?.location_type == 1 ? "Head Office" : item?.location_type == 2 ? "Office" : ""}</>,
            contract_name: <>{item?.contract_id?.name}</>,
            from: <> {item?.from_name} </>,
            to: <> {item?.to_name} </>,
            route: <> {item?.route ? item?.route : '-'} </>,
            rate_type: <> {constant.rateTypeObject[item?.rate_type]} </>,
            rate: <> {item?.rate ? <> &#x20B9; {(item?.rate).toFixed(2)} </> : '-'} </>,
            amount: <> {item?.amount ? <> &#x20B9; {(item?.amount).toFixed(2)} </> : '-'}  </>,
            vehicle_no: <> {item?.vehicle_no ? item?.vehicle_no : '-'}  </>,
            vehicle_type: <> {item?.vehicle_type_name ? item?.vehicle_type_name : '-'} </>,
            vehicle_ownership: <> {item?.vehicle_ownership === 0 ? 'All' : (masterData?.vehicle_ownership[item?.vehicle_ownership] ? masterData?.vehicle_ownership[item?.vehicle_ownership] : '-')} </>,
            status: <>
                <div
                    className="_anvSwitcherNew form-check form-switch"
                    style={{ width: "125px" }}
                >
                    <input
                        className="form-check-input _pi_ter"
                        type="checkbox"
                        name="actStatus"
                        id={`actStatus-${item._id}`}
                        checked={item?.active === 1 ? true : false}
                    // onChange={(e) => handleStatusEvent(item, i)}
                    />
                    <span className={item?.active === 1 ? 'green_status' : 'red_status'}>
                        {item?.active === 1 ? "Active" : "In Active"}
                    </span>
                </div>
            </>,
            fullAddress: item?.address_line1 && <>{`${item?.address_line1} ${item?.address_line1 && item?.address_line2 ? "," : ""} ${item?.address_line2}`}</>,
            stateName: <>{item?.state?.label}</>,

        }));
        return listArray;
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const filterOnhandleSelect = async (item, name) => {
        const stateObj = { ...filter, [name]: item };
        setFilter(stateObj);
    };

    return (
        <div>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />
            <div className="contentHead">
                <div className='d-flex pt-3 pb-3 gap-3'>

                </div>
                <div className='_rSideBtn'>
                    <AddButton
                        onClick={() => setShowOffcanvas(true)}
                        name='Add Location' />
                </div>
            </div>

            <div className='_RtTabWith_tab'>
                <BootstrapTable
                    columns={column}
                    data={rowDataList(
                        detailsData?.locations?.length
                            ? detailsData?.locations
                            : []
                    )}
                />
                {/* <div className='paginationFt_avt '>
                    {renderPagination()}
                </div> */}
                {rateList?.length > 0 && <div className='paginationFt_avt'>
                    <CustomPagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={filter.offset}
                        onPageChange={handlePageChange}
                    />
                </div>}
            </div>

            {show
                && (
                    <AddRateModal {...propsObject} />
                )
            }

            {isRateDetails
                && (
                    <RateDetailsModal {...rateDetailsProps} />
                )
            }

            {
                isDelete?.company_id && (
                    <CommonModal {...contractDeleteProps}>
                        <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
                    </CommonModal>
                )
            }
            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""
                    }`}
                tabIndex={-1}
                style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
            >
                {showOffcanvas && (
                    <AddMasterLocationModal
                        isOpen={showOffcanvas}
                        onClose={(e) => {
                            setAddressId({ id: "", title: "location", view: false });
                            getDataConsignorDetails(id, company_id);
                            setShowOffcanvas(false);
                        }}
                        detailsData={detailsData}
                        id={addressId}
                    />
                )}
            </div>
            <div className={showOffcanvas ? "offBack_drop" : ""}></div>

        </div >
    )
}

export default Location